import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  TextField,
  List,
  ListItem,
  Divider,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import axiosClient from "../axiosClient";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

const AppointmentCommentModal = ({ id, open, handleClose, getAppointment }) => {
  const [comment, setComment] = useState("");
  const [visibility, setVisibility] = useState(true);
  const [comments, setComments] = useState([]);
  const [error, setError] = useState("");

  // Define fetchComments outside of useEffect
  const fetchComments = async () => {
    try {
      const response = await axiosClient.get(`api/comments/${id}/`);
      setComments(response.data);
    } catch (error) {
      console.error("Error fetching comments:", error);
    }
  };

  const validateForm = () => {
    if (!comment.trim()) {
      setError("Comment is required");
      return false;
    }
    setError("");
    return true;
  };

  const handleSave = async () => {
    if (!validateForm()) {
      return;
    }

    try {
      const response = await axiosClient.post("api/comments/create/", {
        appointment: id,
        comment_text: comment,
        visibility: visibility,
      });
      console.log("Comment saved:", response.data);
      fetchComments();
      getAppointment();
      setComment("");
      setVisibility(true);
    } catch (error) {
      if (error.response) {
        console.error("Error response:", error.response);
        alert(`Error saving comment: ${error.response.data}`);
      } else {
        console.error("Error saving comment:", error);
      }
    }
  };

  useEffect(() => {
    if (open) {
      fetchComments();
    }
    // eslint-disable-next-line
  }, [id, open]);

  console.log(comments);

  // Handle modal close events
  const handleModalClose = (event, reason) => {
    // Prevent closing on backdrop click or Escape key press
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }
    setComment("");
    setError("");
    handleClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleModalClose}
      disableEscapeKeyDown
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: "80%", md: 800 },
          maxHeight: "90vh",
          bgcolor: "background.paper",
          border: "2px solid #000",
          boxShadow: 24,
          p: { xs: 2, sm: 4 },
          overflowY: "auto",
        }}
      >
        <Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 1,
            }}
          >
            <Typography
              id="modal-modal-title"
              sx={{ fontSize: { xs: "16px", sm: "18px" }, fontWeight: "500" }}
              variant="h4"
              component="h2"
            >
              Comments
            </Typography>
            <Typography
              onClick={handleModalClose}
              sx={{ cursor: "pointer" }}
              id="modal-modal-title"
              variant="h6"
              component="h2"
            >
              <CloseOutlinedIcon fontSize="medium" />
            </Typography>
          </Box>
          <List>
            {comments.map((comment) => (
              <ListItem key={comment.id}>
                <Typography
                  variant="body1"
                  sx={{ fontSize: { xs: "14px", sm: "16px" } }}
                >
                  <i>
                    {comment.user.username} -{" "}
                    {new Date(comment.created_at).toLocaleString()}
                  </i>{" "}
                  - {comment.visibility ? "visible" : ""}
                  <br />
                  {comment.comment_text}
                </Typography>
                <Divider component="li" />
              </ListItem>
            ))}
          </List>
        </Box>
        <Typography
          variant="h6"
          component="h6"
          sx={{ fontSize: { xs: "14px", sm: "16px" }, mt: 2 }}
        >
          Add Comment
        </Typography>
        <FormControlLabel
          control={
            <Checkbox
              checked={visibility}
              onChange={(e) => setVisibility(e.target.checked)}
              size="small"
            />
          }
          label="View By Client"
          sx={{ fontSize: { xs: "14px", sm: "16px" } }}
        />
        <TextField
          fullWidth
          multiline
          rows={4}
          value={comment}
          variant="outlined"
          onChange={(e) => {
            setComment(e.target.value);
            if (e.target.value.trim()) setError("");
          }}
          placeholder="Enter your comment"
          sx={{ my: 2, fontSize: { xs: "14px", sm: "16px" } }}
          error={!!error}
          helperText={error}
        />
        <Button
          variant="contained"
          onClick={handleSave}
          sx={{
            fontSize: { xs: "14px", sm: "16px" },
            padding: { xs: "8px 16px", sm: "10px 20px" },
          }}
          disabled={!comment.trim()}
        >
          Save
        </Button>
      </Box>
    </Modal>
  );
};

export default AppointmentCommentModal;